import React from "react";
import { TableCell, Typography } from "@mui/material";

export default function NaglowekTablecell({ text }) {
    return (
        <TableCell>
            <Typography mb={-1} style={{ whiteSpace: 'nowrap' }} variant="h4" fontWeight='bold'>{text}</Typography>
        </TableCell>
    )
};